import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { InfoPage, PortalOneColumnLayout } from 'components/PortalStructure';
import { InfoPageHeaderSection, InfoPageHeaderTitle, InfoPageSection, InfoPageTitle1 } from 'components';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
const { asyncConnect } = require('redux-connect');

interface IProps {
	baseUrlClient?: string;
}

@asyncConnect([
	{
		promise: () => {
			return Promise.all([]);
		},
	},
])
@connect((state: IStore) => ({
	baseUrlClient: state.fetchDefault.baseUrlClient,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class PortalDeleteAccountIT extends React.Component<IProps, any> {
	public render() {
		const siteTitle = 'Eliminazione di un account ';
		const siteDescription =
			"Quando elimini il tuo account, tutti i tuoi dati verranno rimossi definitivamente. Per motivi di sicurezza, non possiamo eliminare l'account per te. Se vuoi richiederne la cancellazione dovrai accedere al tuo account.";
		const siteKeywords = 'Delete account keywords';
		const siteImage = this.props.baseUrlClient + '/images/logo.png';
		const siteUrl = this.props.baseUrlClient + '/deleteaccount/it';

		return (
			<PortalOneColumnLayout>
				<InfoPage>
					<InfoPageHeaderSection>
						<img src={require('../../../containers/Html/icons/symbol1.svg')} alt="glossiq icon" />
						<InfoPageHeaderTitle>Eliminazione di un account</InfoPageHeaderTitle>
					</InfoPageHeaderSection>
					<hr />
					<InfoPageSection>
						<p>
							Quando elimini il tuo account, tutti i tuoi dati verranno rimossi definitivamente. Per motivi di
							sicurezza, non possiamo eliminare l'account per te. Se vuoi richiederne la cancellazione dovrai accedere
							al tuo account.
						</p>

						<InfoPageTitle1>Se vuoi richiedere la cancellazione definitiva del tuo account: </InfoPageTitle1>

						<ul>
							<li>
								Accedi al tuo account: visita il sito Web Glossiq.com sul tuo computer o apri l'app mobile e accedi
								utilizzando il nome utente e la password del tuo account.
							</li>

							<li>
								Trova le impostazioni del tuo account: sul computer, fai clic sull'immagine del tuo profilo nell'angolo
								in alto a destra dello schermo, quindi fai clic su
								<Link to="/account">Impostazioni</Link>. Nell'applicazione mobile, fai clic su Profilo nell'angolo
								destro del pulsante, quindi fai clic su Account.
							</li>

							<li>
								Accedi all'opzione per eliminare il tuo account: scorri verso il basso fino alla sezione Disattiva
								account e fai clic sul pulsante "Disattiva il mio account".
							</li>

							<li>
								Conferma la tua intenzione di eliminare l'account: se sei sicuro di eliminare l'account, fai clic sul
								pulsante "Avanti".
							</li>

							<li>
								Fornisci feedback: fornisci una motivazione per la tua decisione o seleziona "Altro" se non desideri
								condividerla, quindi fai clic sul pulsante "Disattiva il mio account" per avviare il processo di
								eliminazione.
							</li>

							<li>
								Controlla la tua email: riceverai un messaggio di conferma che ti confermerà la cancellazione del tuo
								account.
							</li>
						</ul>

						<p>
							Trascorsi 7 giorni dalla richiesta di eliminazione del tuo account, il tuo account e tutti i tuoi dati
							verranno eliminati definitivamente e non potranno essere recuperati.
						</p>
					</InfoPageSection>
				</InfoPage>
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: siteUrl }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: siteImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: siteUrl },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
						{ name: 'keywords', content: siteKeywords },
					]}
				/>
			</PortalOneColumnLayout>
		);
	}
}

export { PortalDeleteAccountIT };
